import MapLocationMarker from "./presentational";
export default MapLocationMarker;
